import React, { useContext, createContext, useState } from 'react';

interface HeaderContextData {
  whatsappStateLoja: boolean;
  whatsappStateGrupo: boolean;
  whatsappNumberLoja: string;
  whatsappNumberGrupo: string;
  asideIsOpen: boolean;

  setWhatsappStateLoja(state: boolean): void;
  setWhatsappStateGrupo(state: boolean): void;
  setWhatsappNumberLoja(number: string): void;
  setWhatsappNumberGrupo(number: string): void;
  setAsideIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeaderContext = createContext<HeaderContextData>({} as HeaderContextData);

const HeaderProvider: React.FC = ({ children }) => {
  const [whatsappStateGrupo, setWhatsappStateGrupo] = useState(false);
  const [whatsappStateLoja, setWhatsappStateLoja] = useState(false);
  const [whatsappNumberGrupo, setWhatsappNumberGrupo] = useState('');
  const [whatsappNumberLoja, setWhatsappNumberLoja] = useState('');
  const [asideIsOpen, setAsideIsOpen] = useState(false);

  return (
    <HeaderContext.Provider
      value={{
        whatsappStateLoja,
        whatsappStateGrupo,
        whatsappNumberLoja,
        whatsappNumberGrupo,
        asideIsOpen,
        setWhatsappStateLoja,
        setWhatsappStateGrupo,
        setWhatsappNumberLoja,
        setWhatsappNumberGrupo,
        setAsideIsOpen,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

function useHeader(): HeaderContextData {
  const context = useContext(HeaderContext);

  if (!context)
    throw new Error('useHeader deve ser utilizado junto do HeaderProvider');

  return context;
}

export { HeaderProvider, useHeader };
